import { PaginationOptions } from "../shared/interfaces/pagination-options.interface";
import { AbstractService } from "../shared/service/abstract-service.service";

export class CampaignsService extends AbstractService {
  resource = "campaigns";

  async getCampaigns(pagination?: PaginationOptions) {
    return await this.get("by/artiste", pagination);
  }
}

export const campaignsService = new CampaignsService();
